import { Box, Card, Typography, useTheme } from '@mui/material';

function StatTile({ title, value, change, changeLabel, trend = 'up', accent }) {
  const theme = useTheme();

  const positive = trend === 'up';

  return (
    <Card
      elevation={0}
      sx={{
        flex: 1,
        backgroundColor: '#fff',
        p: 2.5,
        minHeight: 100,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        border: '1px solid #ECECEC',
        boxShadow: '0 2px 12px rgba(0,0,0,.05)'
      }}>
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 700,
          lineHeight: 1.2,
          mb: 2
        }}>
        {title}
      </Typography>

      <Typography
        sx={{
          fontSize: 24,
          fontWeight: 700,
          lineHeight: 1.1,
          color: accent || theme.palette.text.primary,
          mb: 2
        }}>
        {value}
      </Typography>

      {change !== undefined ? (
        <Box display="flex" alignItems="center" mt={0.25}>
          <Typography
            sx={{
              fontSize: 10,
              fontWeight: 600,
              color: positive ? '#19C37D' : theme.palette.error.main,
              lineHeight: 1
            }}>
            {positive ? '▲' : '▼'} {change}
          </Typography>
        </Box>
      ) : (
        <Typography
          sx={{
            fontSize: 12,
            color: 'text.secondary',
            lineHeight: 1.2,
            mt: 0.25
          }}>
          {changeLabel}
        </Typography>
      )}
    </Card>
  );
}

export default StatTile;
